import { LineItem } from '@repo/ui/src/types/lineItem';
import { ProductOptionValue } from '@repo/ui/src/types/product';
import useUpdateBasket from '@hooks/basket/useUpdateBasket';

export const useToggleProductWarranty = (product: LineItem) => {
  const { trigger: updateBasket, ...rest } = useUpdateBasket();

  const addWarranty = async (warranty: ProductOptionValue) => {
    return updateBasket({
      lineItem: product,
      optionItems: [{ optionId: 'warranty', optionValueId: warranty.id }],
      quantity: product.quantity,
    });
  };

  return { trigger: addWarranty, ...rest };
};
